module.exports = __webpack_public_path__ + "static/media/use_cases.2677d492.svg";